var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStocksIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    fill: "#E6E6E6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8, 7.5) scale(0.66)",
    fill: "#033476"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.6667 6.25c-2.99156 0-5.41668 2.42512-5.41668 5.4167v16.6666c0 2.9916 2.42512 5.4167 5.41668 5.4167h16.6666c2.9916 0 5.4167-2.4251 5.4167-5.4167v-16.6666c0-2.99158-2.4251-5.4167-5.4167-5.4167zm-7.91668 5.4167c0-4.37229 3.54441-7.9167 7.91668-7.9167h16.6666c4.3723 0 7.9167 3.54441 7.9167 7.9167v16.6666c0 4.3723-3.5444 7.9167-7.9167 7.9167h-16.6666c-4.37227 0-7.91668-3.5444-7.91668-7.9167z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.1934 13.5873c.5409.429.6316 1.2153.2026 1.7562l-6.9667 8.7833c-.4041.5095-1.1315.624-1.6727.2633l-4.4834-2.989-5.30329 6.8165c-.42392.5448-1.20928.6429-1.75415.219s-.64292-1.2093-.219-1.7542l6.01664-7.7333c.4021-.5169 1.135-.6358 1.6799-.2725l4.4925 2.995 6.2515-7.8817c.429-.5409 1.2153-.6316 1.7561-.2026z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.6167 14.3667c0-.6904.5596-1.25 1.25-1.25h5.2666c.6904 0 1.25.5596 1.25 1.25v5.25c0 .6903-.5596 1.25-1.25 1.25-.6903 0-1.25-.5597-1.25-1.25v-4h-4.0166c-.6904 0-1.25-.5597-1.25-1.25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStocksIcon);
export default __webpack_public_path__ + "static/media/stocks-icon.980b957ef37a9a8e25e907a0821f18a5.svg";
export { ForwardRef as ReactComponent };